// extracted by mini-css-extract-plugin
export default {"underLine":"text-module__underLine--D9AxH","disableSelection":"text-module__disableSelection--laqRr"};